<template>
  <div>
    <div>
      <ElXlsx @upData="upData" />
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="timeType" label="时间类型">
      </el-table-column>
      <el-table-column prop="value" label="值">
      </el-table-column>
      <el-table-column prop="ratio" label="比例">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import ElXlsx from '../../components/ElXlsx.vue'
  export default {
    components: {
      ElXlsx
    },
    inject: ['reload'],
    data() {
      return {
        tableData: [],
        items: ['timeType', 'value', 'ratio']
      }
    },
    mounted() {
      this.$axios.post('/total_count/findList').then(res => {
        this.tableData = res.data.data
      })
    },
    methods: {
      upData(e) {
        let dataArr = this.$replaceString(e, this.items)
        // console.log(dataArr)
        this.$axios.post('total_count/save', dataArr).then(res => {
          this.$message({
            message: '导入成功。',
            type: 'success'
          })
          this.reload()
        })
      },
    }
  }
</script>

<style scoped>
  .el-table {
    margin-top: 20px;
  }
</style>